<template>
  <div>
    <b-card no-body class="pt-1">
      <div>
        <b-row>
          <b-col cols="12" md="8" class="">
            <b-button
                id="update"
                variant="primary"
                @click="cambiarTipo"
                :disabled="loading"
                v-b-tooltip.hover="'Actualizar data'"
                class="mx-1"
                size="sm"
            >
              <span v-if="loading"
              ><b-spinner style="width: 15px; height: 15px"
              /></span>
              <span v-else><feather-icon icon="RefreshCwIcon"/></span>
            </b-button>
            <b-button
                variant="primary"
                @click="descargarPlantillaExcel"
                v-b-tooltip.hover="'Descargar Plantilla Excel'"
                size="sm"
                class="mr-1"
            >
              <span>
                <font-awesome-icon icon="fa-solid fa-file-excel"/>
              </span>
            </b-button>
            <b-button
                variant="primary"
                @click="descargarPlantillaPDF"
                v-b-tooltip.hover="'Descargar PDF'"
                size="sm"
            >
              <span>
                <font-awesome-icon icon="fa-solid fa-file-pdf"/>
              </span>
            </b-button>
          </b-col>
          <b-col
              cols="12"
              md="4"
          >
            <b-form-group
                label="Tipo: "
                label-cols-md="2"
            >
              <v-select
                  v-model="tipo"
                  label="Tipo"
                  :options="tipoLista"
                  class="select-size-sm mr-1"
                  @input="cambiarTipo()"
                  :clearable="false"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <b-col cols="12" class="mt-0 pt-0">
        <hot-table ref="hotTableAbsentismos" :data="itemsAbsentismos" licenseKey="non-commercial-and-evaluation"
        ></hot-table>
      </b-col>
    </b-card>

    <b-modal
        id="modal-fotos"
        v-model="estadoModalFotos"
        ref="modal-fotos"
        title="Evidencias"
        ok-title="Cerrar"
        ok-only
        size="xl"
        scrollable
        no-close-on-esc
        no-close-on-backdrop
        @ok=""
        @show=""
    >
      <div align="center">
        <swiper
            class="swiper"
            :options="swiperOption"
        >
          <swiper-slide
              v-for="(data,index) in swiperData"
              :key="index"
          >
            <b-img
                :src="`https://prd-cloud.agvperu.com/media/${data.file}`"
                fluid
            />
          </swiper-slide>

          <div
              slot="pagination"
              class="swiper-pagination"
          />
        </swiper>
      </div>
    </b-modal>

    <b-modal
        id="modal-confirmar"
        v-model="estadoModalConfirmar"
        ref="modal-confirmar"
        :title="tituloConfirmar"
        ok-title="Aceptar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        size="sm"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @ok="editarEstado"
        @show=""
    >
      <div align="center">
        <p align="left">Descripción</p>
        <b-form-input
            id="descripcion"
            v-model="observacion"
            name="descripcion"
        />
        <br>
        <p>Por favor, confirmar acción</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axiosIns from '../../libs/axios'
import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCol,
  BForm,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BPagination,
  BRow,
  BSpinner,
  BTable,
  BImg,
  VBModal,
  VBTooltip,
} from 'bootstrap-vue'
import { localize, ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import { HotTable } from '@handsontable/vue'
import { registerAllModules } from 'handsontable/registry'
import { esMX, registerLanguageDictionary } from 'handsontable/i18n'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

import 'handsontable/dist/handsontable.full.css'
import 'swiper/css/swiper.css'
import vSelect from 'vue-select'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

registerAllModules()
registerLanguageDictionary(esMX)

export default {
  components: {
    BCardCode,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BForm,
    BInputGroup,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BInputGroupAppend,
    BTable,
    BPagination,
    BBadge,
    BSpinner,
    BFormDatepicker,
    BImg,
    Swiper,
    SwiperSlide,
    vSelect,
    HotTable,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      totalRows: 0,
      estadoModalFotos: false,
      estadoModalConfirmar: false,
      tituloConfirmar: null,
      itemsAbsentismos: [],
      loading: false,
      loading2: false,
      loadingEditar: false,
      status: [
        {
          0: 'En Proceso',
          1: 'Realizado',
          2: 'Cancelado',
        },
        {
          0: 'light-warning',
          1: 'light-success',
          2: 'light-danger',
        },
      ],

      labels: {
        labelPrevDecade: 'Década anterior',
        labelPrevYear: 'Año anterior',
        labelPrevMonth: 'Mes anterior',
        labelCurrentMonth: 'Mes actual',
        labelNextMonth: 'Mes siguiente',
        labelNextYear: 'Año siguiente',
        labelNextDecade: 'Década siguiente',
        labelToday: 'Hoy',
        labelSelected: 'Fecha seleccionada',
        labelNoDateSelected: 'Seleccione fecha',
        labelCalendar: 'Calendario',
        labelNav: 'Navegación por calendario',
        labelHelp: 'Use las teclas de flecha para navegar por el calendario',
        labelTodayButton: 'Hoy',
        labelResetButton: 'Borrar',
        labelCloseButton: 'Cerrar',
      },

      evento: null,
      n_premios: null,
      descripcion: null,
      fecha_inicio: null,
      fecha_fin: null,

      observacion: null,

      genero: null,
      generoLista: [],

      hijos: null,
      hijosLista: [],

      tipo: 'Descansos Médicos',
      tipoLista: ['Descansos Médicos', 'Subsidios', 'Licencias con Goce'],

      sede: null,
      sedeLista: [],

      opcion: null,
      opcionLista: ['TODOS', 'CALIFICADOS', 'NO CALIFICADOS'],
      opcionBool: false,

      estadoEditarSelected: null,
      estadosEditar: [
        'EN PROCESO',
        'CERRADO',
        'CANCELADO',
      ],

      tableAbsentismos: null,
      settingsAbsentismos: null,

      swiperData2: [
        /* eslint-disable global-require */
        { img: 'https://prd-cloud.agvperu.com/media/fotos_bbss/scaled_9847b337-cf6e-4326-a6cb-62bc7c2b92a27808257257612440925.jpg' },
        { img: require('@/assets/images/banner/banner-39.jpg') },
        { img: require('@/assets/images/banner/banner-28.jpg') },
        { img: require('@/assets/images/banner/banner-29.jpg') },
        { img: require('@/assets/images/banner/banner-30.jpg') },
        /* eslint-disable global-require */
      ],

      swiperData: [],

      swiperOption: {
        slidesPerView: 3,
        slidesPerColumn: 2,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
      },

      id_file: null,
      id_foto: null,
      estado_file: null,

      required,
    }
  },
  computed: {},
  mounted() {
    this.tableAbsentismos = this.$refs.hotTableAbsentismos.hotInstance
    localize('es')
    this.traerDescansos()
  },
  methods: {
    traerDescansos() {
      const yo = this
      yo.loading = true
      yo.tableAbsentismos.updateData([])

      const config = {
        method: 'get',
        url: '/bbss/absentismos/descanso_medico/'
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              yo.itemsAbsentismos = response.data
              yo.totalRows = yo.itemsAbsentismos.length
              yo.settingsAbsentismos = {
                width: '100%', //Ancho
                height: '59vh', //Alto
                rowHeaders: true,
                colHeaders: [
                  'ID',
                  'ESTADO',
                  'CODIGO SAP',
                  'DNI',
                  'NOMBRES',
                  'CARGO',
                  'SEDE',
                  'CODIGO ABS.',
                  'DESCRIPCION',
                  'FECHA INICIO',
                  'FECHA FIN',
                  'TOTAL DIAS',
                  'CODIGO COMPL.',
                  'FECHA OTORGAMIENTO',
                  'CODIGO DOCUMENTO',
                  'FECHA INCIDENTE',
                  'TIPO ATENCION',
                  'MEDICO TRATANTE',
                  'DIAG. GENERAL',
                  'DIAG. ESPECIFICO',
                  'EVALUADOR',
                  'FECHA CREACION'
                ],
                columns: [
                  {
                    data: 'id',
                    type: 'numeric',
                  },
                  {
                    data: 'estado',
                    editor: 'select',
                    selectOptions: [],
                    allowInvalid: false,
                    renderer(instance, td, row, col, prop, value, cellProperties) {

                      const spd = value === '1' ? 'light-warning' : value === '3' ? 'light-success' : value === '4' ? 'light-primary' : value === '5' ? 'light-danger' : 'light-dark'
                      const spd2 = value === '1' ? 'En Proceso' : value === '3' ? 'Validado por Salud' : value === '4' ? 'Validado por BBSS' : value === '5' ? 'Desaprobado por Salud' : 'Desaprobado por BBSS'
                      td.className = 'htCenter htMiddle'
                      td.innerHTML = '<b-badge class="badge badge-' + spd + '">' + spd2 + '</b-badge>'

                      return td
                    }
                  },
                  {
                    data: 'cod_sap',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'dni',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'nombres',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'puesto',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'sede',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'cod_abs',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'descripcion',
                    type: 'numeric',
                    className: 'htMiddle',
                    numericFormat: {
                      pattern: '0,0'
                    },
                  },
                  {
                    data: 'fecha_inicio',
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                    className: 'htCenter htMiddle',
                  },
                  {
                    data: 'fecha_fin',
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                    className: 'htCenter htMiddle',
                  },
                  {
                    data: 'total_dias',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'cod_compl',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'fecha_otorgamiento',
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                    className: 'htCenter htMiddle',
                  },
                  {
                    data: 'cod_documento',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'fecha_incidente',
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                    className: 'htCenter htMiddle',
                  },
                  {
                    data: 'tipo_atencion',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'medico_tratante',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'diagnostico_general',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'diagnostico_especifico',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'nombre_evaluador',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'date_created',
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                    className: 'htCenter htMiddle',
                  },
                ],
                contextMenu: {
                  items: {
                    aprobar_salud: {
                      name: 'Aprobar por Salud',
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        if (rowData[1] === '1') {
                          yo.confirmar('¿Aprobar registro?', rowData[0], '3')
                        }
                      },
                    },
                    aprobar_bbss: {
                      name: 'Aprobar por BBSS',
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        if (rowData[1] === '3') {
                          yo.confirmar('¿Aprobar registro?', rowData[0], '4')
                        }
                      },
                    },
                    desaprobar_salud: {
                      name: 'Desaprobar por Salud',
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        if (rowData[1] === '1') {
                          yo.confirmar('¿Desaprobar registro?', rowData[0], '5')
                        }
                      },
                    },
                    desaprobar_bbss: {
                      name: 'Desaprobar por BBSS',
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        if (rowData[1] === '3') {
                          yo.confirmar('¿Desaprobar registro?', rowData[0], '6')
                        }
                      },
                    },
                    view: {
                      name: 'Ver Evidencia',
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        yo.verEvidencia(rowData[0])
                      },
                    },
                  },
                },
                bindRowsWithHeaders: true,
                readOnly: true,
                dropdownMenu: ['filter_by_condition', 'filter_by_value', 'filter_action_bar'], // Activar menú
                filters: true,// Activar Filtro
                columnSorting: true, // Ordenar por columna
                manualColumnResize: true,
                hiddenColumns: {
                  columns: [0],
                  indicators: false
                },
                language: esMX.languageCode,
                locale: 'es-MX',
                stretchH: 'all',
                // fixedColumnsStart: 1,
              }

              yo.tableAbsentismos.updateData(yo.itemsAbsentismos)
              yo.tableAbsentismos.updateSettings(yo.settingsAbsentismos)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            yo.loading = false
          })

    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      const yo = this
      this.$refs.formularioEvento.validate()
          .then((success) => {
            if (success) {
              yo.loading2 = true

              const data = JSON.stringify({
                nombre: yo.evento,
                descripcion: yo.descripcion,
                observacion: '',
                fecha_inicio: yo.fecha_inicio,
                fecha_fin: yo.fecha_fin,
                anio: yo.fecha_inicio.split('-')[0],
                tipo: yo.tipo.map((opcion) => opcion.key_tipo_planilla),
                tipostatic: yo.tipoListaStatic
                    .filter((invoice) => invoice.key_tipo_planilla !== 'TODOS')
                    .map((opcion) => opcion.key_tipo_planilla),
                sede: yo.sede.map((opcion) => opcion.key_sede),
                sedestatic: yo.sedeListaStatic
                    .filter((invoice) => invoice.key_sede !== 'TODOS')
                    .map((opcion) => opcion.key_sede),
                opcion: yo.opcion,
                genero: yo.genero.genero,
                hijos: yo.hijos.asignacion_familiar,
                n_premios: yo.n_premios,
                estado: '0',
                con_usuario: yo.getUserID(),
              })

              const config = {
                method: 'post',
                url: 'evento/registrar/',
                headers: {
                  'Content-Type': 'application/json',
                },
                data: data,
              }
            }
          })
    },
    resetModal() {
      this.evento = null
      this.descripcion = null
      this.fecha_inicio = null
      this.fecha_fin = null
      this.genero = null
      this.hijos = null
      this.tipo = null
      this.sede = null
      this.opcion = null
      this.n_premios = null
      this.opcionBool = false
    },
    cambiarTipo() {
      const yo = this
      if (yo.tipo === 'Descansos Médicos') {
        yo.traerDescansos()
      } else if (yo.tipo === 'Subsidios') {
        yo.traerSubsidios()
      } else if (yo.tipo === 'Licencias con Goce') {
        yo.traerLicencias()
      }
    },
    traerSubsidios() {
      const yo = this
      yo.loading = true
      yo.tableAbsentismos.updateData([])

      const config = {
        method: 'get',
        url: '/bbss/absentismos/subsidio/'
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              yo.itemsAbsentismos = response.data
              yo.totalRows = yo.itemsAbsentismos.length
              yo.settingsAbsentismos = {
                width: '100%', //Ancho
                height: '59vh', //Alto
                rowHeaders: true,
                colHeaders: ['ID', 'ESTADO', 'CODIGO SAP', 'DNI', 'NOMBRES', 'CARGO', 'SEDE', 'CODIGO ABS.', 'DESCRIPCION', 'FECHA INICIO', 'FECHA FIN', 'CODIGO COMPL.', 'FECHA INCIDENTE', 'FECHA OTORGAMIENTO', 'CODIGO DOCUMENTO', 'EVALUADOR', 'FECHA CREACION'],
                columns: [
                  {
                    data: 'id',
                    type: 'numeric',
                  },
                  {
                    data: 'estado',
                    editor: 'select',
                    selectOptions: [],
                    allowInvalid: false,
                    renderer(instance, td, row, col, prop, value, cellProperties) {

                      const spd = value === '1' ? 'light-warning' : value === '3' ? 'light-success' : value === '4' ? 'light-primary' : value === '5' ? 'light-danger' : 'light-dark'
                      const spd2 = value === '1' ? 'En Proceso' : value === '3' ? 'Validado por Salud' : value === '4' ? 'Validado por BBSS' : value === '5' ? 'Desaprobado por Salud' : 'Desaprobado por BBSS'
                      td.className = 'htCenter htMiddle'
                      td.innerHTML = '<b-badge class="badge badge-' + spd + '">' + spd2 + '</b-badge>'

                      return td
                    }
                  },
                  {
                    data: 'cod_sap',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'dni',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'nombres',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'puesto',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'sede',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'cod_abs',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'descripcion',
                    type: 'numeric',
                    className: 'htMiddle',
                    numericFormat: {
                      pattern: '0,0'
                    },
                  },
                  {
                    data: 'fecha_inicio',
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                    className: 'htCenter htMiddle',
                  },
                  {
                    data: 'fecha_fin',
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                    className: 'htCenter htMiddle',
                  },
                  {
                    data: 'cod_compl',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'fecha_incidente',
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                    className: 'htCenter htMiddle',
                  },
                  {
                    data: 'fecha_otorgamiento',
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                    className: 'htCenter htMiddle',
                  },
                  {
                    data: 'cod_documento',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'nombre_evaluador',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'date_created',
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                    className: 'htCenter htMiddle',
                  }
                ],
                contextMenu: {
                  items: {
                    aprobar_salud: {
                      name: 'Aprobar por Salud',
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        if (rowData[1] === '1') {
                          yo.confirmar('¿Aprobar registro?', rowData[0], '3')
                        }
                      },
                    },
                    aprobar_bbss: {
                      name: 'Aprobar por BBSS',
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        if (rowData[1] === '3') {
                          yo.confirmar('¿Aprobar registro?', rowData[0], '4')
                        }
                      },
                    },
                    desaprobar_salud: {
                      name: 'Desaprobar por Salud',
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        if (rowData[1] === '1') {
                          yo.confirmar('¿Desaprobar registro?', rowData[0], '5')
                        }
                      },
                    },
                    desaprobar_bbss: {
                      name: 'Desaprobar por BBSS',
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        if (rowData[1] === '3') {
                          yo.confirmar('¿Desaprobar registro?', rowData[0], '6')
                        }
                      },
                    },
                    view: {
                      name: 'Ver Evidencia',
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        yo.verEvidencia(rowData[0])
                      },
                    },
                  },
                },
                bindRowsWithHeaders: true,
                readOnly: true,
                dropdownMenu: ['filter_by_condition', 'filter_by_value', 'filter_action_bar'], // Activar menú
                filters: true,// Activar Filtro
                columnSorting: true, // Ordenar por columna
                manualColumnResize: true,
                hiddenColumns: {
                  columns: [0],
                  indicators: false
                },
                language: esMX.languageCode,
                locale: 'es-MX',
                stretchH: 'all',
                // fixedColumnsStart: 1,
              }

              yo.tableAbsentismos.updateData(yo.itemsAbsentismos)
              yo.tableAbsentismos.updateSettings(yo.settingsAbsentismos)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            yo.loading = false
          })

    },
    traerLicencias() {
      const yo = this
      yo.loading = true
      yo.tableAbsentismos.updateData([])

      const config = {
        method: 'get',
        url: '/bbss/absentismos/licencia_goce/'
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              yo.itemsAbsentismos = response.data
              yo.totalRows = yo.itemsAbsentismos.length
              yo.settingsAbsentismos = {
                width: '100%', //Ancho
                height: '59vh', //Alto
                rowHeaders: true,
                colHeaders: ['ID', 'ESTADO', 'CODIGO SAP', 'DNI', 'NOMBRES', 'CARGO', 'SEDE', 'CODIGO ABS.', 'DESCRIPCION', 'FECHA INICIO', 'FECHA FIN', 'CODIGO COMPL.', 'CLASE ABS.', 'OBSERVACION', 'EVALUADOR', 'FECHA CREACION'],
                columns: [
                  {
                    data: 'id',
                    type: 'numeric',
                  },
                  {
                    data: 'estado',
                    editor: 'select',
                    selectOptions: [],
                    allowInvalid: false,
                    renderer(instance, td, row, col, prop, value, cellProperties) {

                      const spd = value === '1' ? 'light-warning' : value === '4' ? 'light-success' : 'light-danger'
                      const spd2 = value === '1' ? 'En Proceso' : value === '4' ? 'Validado' : 'Desaprobado'
                      td.className = 'htCenter htMiddle'
                      td.innerHTML = '<b-badge class="badge badge-' + spd + '">' + spd2 + '</b-badge>'

                      return td
                    }
                  },
                  {
                    data: 'cod_sap',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'dni',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'nombres',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'puesto',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'sede',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'cod_abs',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'descripcion',
                    type: 'numeric',
                    className: 'htMiddle',
                    numericFormat: {
                      pattern: '0,0'
                    },
                  },
                  {
                    data: 'fecha_inicio',
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                    className: 'htCenter htMiddle',
                  },
                  {
                    data: 'fecha_fin',
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                    className: 'htCenter htMiddle',
                  },
                  {
                    data: 'cod_compl',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'clase',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'otorga',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'nombre_evaluador',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'date_created',
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                    className: 'htCenter htMiddle',
                  }
                ],
                contextMenu: {
                  items: {
                    aprobar: {
                      name: 'Aprobar',
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        if (rowData[1] === '1') {
                          yo.confirmar('¿Aprobar registro?', rowData[0], '4')
                        }
                      },
                    },
                    desaprobar: {
                      name: 'Desaprobar',
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        if (rowData[1] === '1') {
                          yo.confirmar('¿Desaprobar registro?', rowData[0], '6')
                        }
                      },
                    },
                    view: {
                      name: 'Ver Evidencia',
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        yo.verEvidencia(rowData[0])
                      },
                    },
                  },
                },
                bindRowsWithHeaders: true,
                readOnly: true,
                dropdownMenu: ['filter_by_condition', 'filter_by_value', 'filter_action_bar'], // Activar menú
                filters: true,// Activar Filtro
                columnSorting: true, // Ordenar por columna
                manualColumnResize: true,
                hiddenColumns: {
                  columns: [0],
                  indicators: false
                },
                language: esMX.languageCode,
                locale: 'es-MX',
                stretchH: 'all',
                // fixedColumnsStart: 1,
              }

              yo.tableAbsentismos.updateData(yo.itemsAbsentismos)
              yo.tableAbsentismos.updateSettings(yo.settingsAbsentismos)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            yo.loading = false
          })

    },
    confirmar(titulo, id, estado) {
      const yo = this
      yo.observacion = null
      yo.tituloConfirmar = titulo
      yo.estadoModalConfirmar = true
      yo.id_file = id
      yo.estado_file = estado
    },
    verEvidencia(id) {
      const yo = this
      yo.id_foto = id

      const data = JSON.stringify({
        id: yo.id_foto,
        tipo: yo.tipo
      })

      const config = {
        method: 'post',
        url: '/bbss/absentismos/fotos/view/',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              yo.swiperData = response.data
              console.log(yo.swiperData)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            yo.estadoModalFotos = true
          })

    },
    descargarPlantillaExcel() {
      const yo = this
      const arrays = yo.tableAbsentismos.getData()
      const data_new = arrays.map(a => a[0])

      const data = JSON.stringify({
        'ids': data_new,
        'tipo': yo.tipo
      })

      const config = {
        method: 'post',
        url: '/bbss/absentismos/exportar/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
        data: data
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {

              const fileURL = window.URL.createObjectURL(
                  new Blob([response.data])
              )
              const fileLink = document.createElement('a')
              fileLink.href = fileURL

              fileLink.setAttribute(
                  'download',
                  'absentismos.xlsx'
              )
              document.body.appendChild(fileLink)
              fileLink.click()

              yo.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  }
              )

            }
          })
          .catch(function (error) {
            console.log(error)
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {

          })

      /*
      const fileURL = window.URL.createObjectURL(new Blob([]));
      console.log(fileURL);
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', "Registro Masivo para Absentismo.xlsx");
      document.body.appendChild(fileLink);
      fileLink.click();
      */
    },
    descargarPlantillaPDF() {

      const yo = this
      const arrays = yo.tableAbsentismos.getData()
      const data_new = arrays.map(a => a[0])

      const data = JSON.stringify({
        'ids': data_new,
        'tipo': yo.tipo
      })

      const config = {
        method: 'post',
        url: '/bbss/absentismos/exportar/pdf/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
        data: data
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {

              const fileURL = window.URL.createObjectURL(
                  new Blob([response.data])
              )
              const fileLink = document.createElement('a')
              fileLink.href = fileURL

              fileLink.setAttribute(
                  'download',
                  'absentismos.zip'
              )
              document.body.appendChild(fileLink)
              fileLink.click()

              yo.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  }
              )

            }
          })
          .catch(function (error) {
            console.log(error)
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {

          })

      /*
      const fileURL = window.URL.createObjectURL(new Blob([]))
      console.log(fileURL)
      const fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', 'Reporte de Absentismo.zip')
      document.body.appendChild(fileLink)
      fileLink.click()
      */
    },
    editarEstado() {
      const yo = this
      const data = JSON.stringify({
        id: yo.id_file,
        estado: yo.estado_file,
        tipo: yo.tipo,
        observacion: yo.observacion
      })

      const config = {
        method: 'post',
        url: 'bbss/absentismos/editar/estado/',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200 && response.data.status) {
              yo.mostrarNotificacion(
                  'Edición Exitosoa',
                  'CheckIcon',
                  'Se editó el estado correctamente',
                  'success'
              )
            } else if (response.status !== 200 && !response.data.status) {
              yo.mostrarNotificacion(
                  'Error',
                  'BellIcon',
                  'Error en la edición, favor de intentar nuevamente.',
                  'danger'
              )
            }
          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            yo.estadoModalEditar = false
            yo.loadingEditar = false
            if(yo.tipo === 'Descansos Médicos'){
              yo.traerDescansos()
            }else if(yo.tipo === 'Subsidios'){
              yo.traerSubsidios()
            }else if(yo.tipo === 'Licencias con Goce'){
              yo.traerLicencias()
            }

          })
    },
    mostrarNotificacion(titulo, icono, texto, variante) {
      this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante,
            },
          },
          {
            position: "top-center",
            timeout: 5500,
          }
      );
    },
  },

}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.alinear-una-sola-linea {
  white-space: nowrap !important;
}

.min-400 {
  min-width: 350px !important;
}

.alinear-medio {
  vertical-align: middle !important;
}

.swiper {

  ::v-deep .swiper-wrapper {
    flex-direction: row !important;
  }

  .swiper-slide {
    margin-top: 30px;
  }
}
</style>
